<template>
	<sf-modal-layout size="l" :title="title" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<car-sale-popup-search ref="searchGb" :scrId="scrId" :pmcNum="propCarSaleNo" />
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<car-sale-popup-table ref="table" @close="close" @reload="reload" @SendPmcData="sendPmcData" :scrId="scrId" />
				</sf-card>
			</div>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="close">
				{{ getMessage_('SWCC000113') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from './store/helpers';
import CarSalePopupTable from './Content/Table/CarSalePopupTable.vue';
import CarSalePopupSearch from './Content/Search/CarSalePopupSearch.vue';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { CarSalePopupTable, CarSalePopupSearch },

	data() {
		return {
			show: false,
			title: 'PMC 판매정보 조회',
			propCarSaleNo: '',
			popUpType: '' //팝업호출구분값 :RO 또는 PWA
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			//console.log(param);
			this.setStateInit_();
			this.show = true;
			//this.propCarSaleNo = param;
			this.popUpType = param.popUpType;
			this.setSearchParam_({ key: 'pmcId', value: param.pmcId }); //input에 param값입력
			this.setSearchParam_({ key: 'cmpnNo', value: param.cmpnNo }); //input에 param값입력
			this.setSearchParam_({ key: 'roApcnch', value: param.roApcnch }); //input에 param값입력
			if (this.$refs.searchGb != undefined) {
				this.$refs.searchGb.search();
			}
		},
		close() {
			this.setSearchParam_({ key: 'pmcId', value: null });
			this.$refs.searchGb.reset();
			this.show = false;
		},
		//partPopupSearch페이지 새로고침
		reload() {
			this.$refs.searchGb.search();
		},
		sendPmcData(sendParam) {
			//console.log('sendParam>>>>', sendParam);
			if (this.popUpType == 'RO') {
				this.chkPmcIdCampNo_(sendParam.pmcId)
					.then(response => {
						if (response.header.message != undefined && response.header.message != null) {
							let tmpCmpnNoList = '';
							if (response.body.result != undefined && response.header.message != null) {
								tmpCmpnNoList = convertNvl(response.body.result.cmpnNmList, '');
							}
							sendParam.cmpnNoList = tmpCmpnNoList;

							this.$emit('SendPmcData', sendParam);
							this.close();
						}
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			} else {
				this.$emit('SendPmcData', sendParam);
				this.close();
			}
		}
	},
	created() {
		//들어오자마자 state 초기화 하는 방법
		this.setStateInit_();
		this.screen = this.screenArray.get(this.scrId);
	}
};
</script>

<style></style>
